import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPointUrl } from './api.enum';
import {AppService} from "../../../core/services/app.service";

@Injectable({
  providedIn: 'root'
})

export class _CampagneService {
  constructor(private service: AppService) {
  }

  GetFormation(data, page): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_FORMATION).replace('{page}', page);
    return this.service.postData(`${url}`, data);
  }

  getAllDirection(data): Observable<any> {
    const url: string = (<string>EndPointUrl.DIRECTION);
    return this.service.getData(`${url}`);
  }

  getAllClassification(data): Observable<any> {
    const url: string = (<string>EndPointUrl.CLASSIFICATION);
    return this.service.postData(`${url}`, data);
  }

  getAllStructureById(data): Observable<any> {
    const url: string = (<string>EndPointUrl.STRUCTURE).replace('{direction_id}', data);
    return this.service.getData(`${url}`);
  }

  getStatisticCampagne(campagne_id): Observable<any> {
    const url: string = (<string>EndPointUrl.STATISTIC_DASHBOARD).replace('{campagne_id}', campagne_id);
    return this.service.getData(`${url}`);
  }

  GetAllStructure(): Observable<any> {
    const url: string = (<string>EndPointUrl.STRUCTURE_ALL);
    return this.service.postData(`${url}`, {});
  }

  GetCategorie(): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_CATEG);
    return this.service.postData(`${url}`, {});
  }

  GetPostes(): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_POSTE);
    return this.service.postData(`${url}`, {});
  }

  GetCampagne(): Observable<any> {
    const url: string = (<string>EndPointUrl.GET_CAMPAGNE);
    return this.service.getData(`${url}`);
  }

  }
